// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
var Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var ConversationParticipantProfilePhoto_participant_graphql = require("../../__generated__/ConversationParticipantProfilePhoto_participant_graphql.bs.js");

var convertFragment = ConversationParticipantProfilePhoto_participant_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationParticipantProfilePhoto_participant_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__ParticipantProfilePhoto(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : "tiny";
  var participant = use(props.participant);
  switch (participant.__typename) {
    case "Agent" :
        return JsxRuntime.jsx(Avatar__Jsx3.make, {
                    src: Core__Option.getOr(Core__Option.map(participant.profilePhoto, (function (param) {
                                return param.url;
                              })), AvatarSrcUrl.place_holder),
                    name: participant.displayName,
                    size: size
                  });
    case "AnonymousConversationParticipant" :
        return JsxRuntime.jsx(Avatar__Jsx3.make, {
                    src: AvatarSrcUrl.place_holder,
                    name: "Agent chose to hide their name",
                    size: size
                  });
    case "__unselected" :
        return UnselectedUnionMemberError.raise("unselected union member " + participant._0 + " on conversation participant");
    
  }
}

var placeholder = AvatarSrcUrl.place_holder;

var make = Conversation__ParticipantProfilePhoto;

exports.Fragment = Fragment;
exports.placeholder = placeholder;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
